import "./Content.scss";

const Content = ({ children }) => {
  return (
    <div id="wrap">
      <div id="contents">{children}</div>
    </div>
  );
};

export default Content;
